var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82221 11.7326L6.26792 16.1783C6.42864 16.3388 6.64649 16.429 6.87364 16.429C7.10078 16.429 7.31864 16.3388 7.47935 16.1783L16.3022 7.35543C16.3465 7.31305 16.3808 7.2613 16.4026 7.20395C16.4243 7.14661 16.433 7.08513 16.4279 7.02401L15.7536 2.64686C15.7481 2.54256 15.7042 2.44398 15.6304 2.37013C15.5565 2.29627 15.4579 2.25236 15.3536 2.24686L10.9765 1.57258C10.9154 1.5675 10.8539 1.57616 10.7965 1.59791C10.7392 1.61966 10.6874 1.65396 10.6451 1.69829L1.82221 10.5211C1.66169 10.6819 1.57153 10.8997 1.57153 11.1269C1.57153 11.354 1.66169 11.5719 1.82221 11.7326Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3031 6.26969C12.1516 6.26969 12.0062 6.20948 11.8991 6.10232C11.7919 5.99516 11.7317 5.84981 11.7317 5.69826C11.7317 5.54671 11.7919 5.40136 11.8991 5.2942C12.0062 5.18703 12.1516 5.12683 12.3031 5.12683C12.4547 5.12683 12.6 5.18703 12.7072 5.2942C12.8143 5.40136 12.8745 5.54671 12.8745 5.69826C12.8745 5.84981 12.8143 5.99516 12.7072 6.10232C12.6 6.20948 12.4547 6.26969 12.3031 6.26969Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagBlack);
export default __webpack_public_path__ + "static/media/tag-black.0a810cbf9600dc712ffd702ddf1ab290.svg";
export { ForwardRef as ReactComponent };